import { AfterContentInit, AfterViewInit, Component, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { AppModeService } from '../../angular-wallet-base/services/app-mode.service';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { take } from 'rxjs/operators';
import { NavController, ViewDidEnter } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { SecurityComponent } from './security/security.component';
import { AuthService } from 'src/app/angular-wallet-base/services/auth.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { RoutingService } from '../../angular-wallet-base/services/routing.service';

@Component({
  selector: 'settings',
  templateUrl: 'settings.page.html',
  styleUrls: ['settings.page.scss']
})
export class SettingsPage extends SubscriptionListenerComponent implements OnInit, ViewDidEnter, OnDestroy {

  @ViewChild(SecurityComponent) security: SecurityComponent;
  public currentTab: string;
  public isDesktopMode: boolean;
  public isBiometricActive: boolean = false;
  public phrase: any;

  constructor(
    protected store: Store<AppState>,
    private nav: NavController,
    private route: ActivatedRoute,
    public appMode: AppModeService,
    private authService: AuthService,
    private routingService: RoutingService
  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    setTimeout(() => {
    this.currentTab = 'preferences';
    this.setSettingsState();
    }, 400);

  }


  ngOnDestroy(): void {
    this.authService.setRecoveryPhrase(null);
  }
  async ngOnInit() {
    // await this.setSettingsState();
  }

  async ionViewDidEnter() {
    // await this.setSettingsState();
  }

  setSettingsState() {
    this.subscriptions.add(this.authService.recoveryPhraseData.subscribe((data) => {
      this.phrase = data;
      if (this.phrase) {
        this.currentTab = 'wallet';
      }
    })
    );
    Logger.info("this.currentTab ",this.currentTab)
  }


  async segmentChanged(event) {
    const nextTab = event.target.value;
    const ionButton = document.getElementById(nextTab);
    try {
      ionButton.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    } catch (error) { }
    this.currentTab = nextTab;
  }

  async goBack() {
    await this.routingService.goHome();
  }

}
